module.exports = __webpack_public_path__ + "static/img/designGuide4.eeed7a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide4.png
// module id = BnFJ
// module chunks = 2